import { render } from "./AssetsComponent.vue?vue&type=template&id=6175a1dd&scoped=true"
import script from "./AssetsComponent.vue?vue&type=script&lang=js"
export * from "./AssetsComponent.vue?vue&type=script&lang=js"

import "./AssetsComponent.vue?vue&type=style&index=0&id=6175a1dd&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6175a1dd"]])

export default __exports__